import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { PageWrapper } from "@/components/PageWrapper";
import ShowcaseView from "@/components/ShowcaseView";
import { showcaseViewProps, useShowcaseFeed } from "@/pages/embed/ShowcaseEmbed";
import "./ShowcaseHostedPage.scss";

const ShowcaseHostedPage = () => {
  const { slug } = useParams();
  const feed = useShowcaseFeed({ slug });
  const name = feed.first?.brokerage?.name;
  const unavailable = feed.query.isError || (feed.first && feed.first.live === false);

  useEffect(() => {
    if (name) document.title = `Buyers working with ${name} agents | Gitcha`;
  }, [name]);

  return (
    <PageWrapper>
      <main className="showcase-hosted">
        {unavailable ? (
          <div className="showcase-hosted__gone">
            <h1>This page is not available right&nbsp;now</h1>
            <p>The brokerage may have paused it. Browse local agents and their buyers in the agent&nbsp;directory.</p>
            <Link className="showcase-hosted__link" to="/agents">
              Open the agent directory
            </Link>
          </div>
        ) : (
          <ShowcaseView {...showcaseViewProps(feed)} />
        )}
      </main>
    </PageWrapper>
  );
};

export default ShowcaseHostedPage;
